export const TODOS = [
  {
    id: 1,
    title: "Home work",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    checked: false,
    createdAt: new Date().toISOString().split("T")[0],
    finshedAt: new Date().toISOString().split("T")[0],
  },
  {
    id: 2,
    title: "Sport",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam",
    checked: false,
    createdAt: new Date().toISOString().split("T")[0],
    finshedAt: new Date().toISOString().split("T")[0],
  },
];

export default TODOS;
